/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import Description from 'DesignSystem/Description/index'
import DescriptionLabel from 'DesignSystem/DescriptionLabel/index'
import DescriptionValue from 'DesignSystem/DescriptionValue/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Summary/Content/Content/Status/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let statusNameValueData = fromData.useDataValue({ viewPath,
context: 'status',
path: 'name',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<Description
  viewPath={`${viewPath}/Description`}
 marginTop={dtSpaceXxs}
 justifyContent="flex-start"
>
{childProps => (
<React.Fragment>
<DescriptionLabel
{...childProps}
  viewPath={`${viewPath}/DescriptionLabel`}
 alignItems="flex-start"
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="normal"
 weight="semibold"
 text="Tx status"
/>
)}
</DescriptionLabel>
<DescriptionValue
{...childProps}
  viewPath={`${viewPath}/DescriptionValue`}
 alignSelf="center"
>
{childProps => (
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral900}
 marginLeft={dtSpaceXxs}
 data="status.name"
 text={statusNameValueData}
/>
)}
</DescriptionValue>
</React.Fragment>
)}
</Description>
{children}
</React.Fragment>)
}